var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M85.74,30.77a5.12,5.12,0,0,0-4.15-3.45l-23-3.45L48.13,3.52a5.21,5.21,0,0,0-9.26,0L28.43,23.87l-23,3.45a5.12,5.12,0,0,0-4.15,3.45A5,5,0,0,0,2.55,36L19.1,52,15.32,74.47,15.07,76h.22a5,5,0,0,0,2.11,3.5,5.22,5.22,0,0,0,5.41.38L43.5,69.35,64.19,79.84a5.69,5.69,0,0,0,2.49.55,5.25,5.25,0,0,0,3.86-1.83,5,5,0,0,0,1.14-4.09L67.89,52,84.45,36A5,5,0,0,0,85.74,30.77ZM57.24,51l2.53,15.11-13.9-7.07a5.21,5.21,0,0,0-4.74,0l-13.9,7.07L29.76,51a5.08,5.08,0,0,0-1.47-4.47L17.19,35.86l15.41-2.3a5.15,5.15,0,0,0,3.88-2.74l7-13.69,7,13.7a5.14,5.14,0,0,0,3.87,2.73l15.42,2.3L58.7,46.58A5.06,5.06,0,0,0,57.24,51Z","fill":"#f1b860","key":1})]);
}

Star.defaultProps = {"viewBox":"0 0 86 80.93"};

module.exports = Star;

Star.default = Star;
